{
  "questionnaire": {
    "welcomeIntro": "Aidez-nous à vous installer en répondant à quelques questions rapides",
    "step": "Étape",
    "steps": "Étape {{ currentStep }} de {{ totalSteps }}",
    "reason": {
      "question": "Dites-nous ce qui vous a amené chez Iventis aujourd'hui ?",
      "options": {
        "SitePlanForMyEvent": "Pour créer un plan du site pour mon événement",
        "TeamPlanMoreEfficiently": "Découvrez comment mon équipe peut planifier plus efficacement",
        "PlanMultipleEventsPerProject": "Découvrez comment planifier plusieurs événements ou projets",
        "JustCurious": "Juste curieux"
      }
    },
    "eventType": {
      "question": "Et que comptes-tu planifier ?",
      "options": {
        "SportsEvent": "Événement sportif",
        "RoadEvent": "Événement routier",
        "FestivalOrParade": "Festival ou défilé",
        "ExhibitionOrShow": "Expositions et conférences",
        "MajorEvent": "Événement majeur",
        "MultipleEvents": "Évènements multiples",
        "Venue": "Un lieu",
        "SomethingElse": "Autre chose"
      }
    },
    "experience": {
      "question": "Quelle est votre expérience avec les outils de planification ?",
      "options": {
        "HaventUsedBefore": "Je n'en ai jamais utilisé auparavant",
        "Powerpoint": "PowerPoint d'occasion",
        "GoogleEarth": "Applications d'occasion comme Google Earth",
        "GisAndCadSoftware": "Logiciels SIG et CAO d'occasion",
        "Iventis": "J'ai déjà utilisé Iventis"
      }
    },
    "projectName": {
      "question": "Et enfin, quel nom avez-vous en tête pour votre projet aujourd'hui ?",
      "subLabel": "Conseil : il peut s'agir du nom de votre événement ou de votre entreprise.",
      "options": {
        "projectName": "Nom du projet"
      },
      "label": "Entrez un nom pour votre projet :"
    },
    "skip": "Ignorez pour l'instant",
    "ending_screen": {
      "initial_loading": {
        "message": "Nous sommes juste en train de configurer les choses pour vous",
        "subtext": "Configuration de votre projet et analyse de vos besoins",
        "footerText": "Cela peut prendre quelques secondes"
      },
      "taking_longer": {
        "message": "Cela prend un peu plus de temps que prévu, accrochez-vous !",
        "subtext": "Perfectionner nos outils pour obtenir les meilleurs résultats",
        "footerText": "Cela peut prendre quelques secondes"
      },
      "error": {
        "message": "Oups, quelque chose ne va pas.",
        "subtext": "Il semble y avoir un problème de notre côté.",
        "footer_1": "Veuillez",
        "footer_2": "afin que nous puissions vous aider à comprendre ce qui s'est passé."
      }
    },
    "setup_completed": "Configuration terminée"
  },
  "passwordConditions": {
    "commonPassword": "Le mot de passe est trop simple. Essayez quelque chose de plus complexe, s'il vous plaît."
  },
  "verification": {
    "headings": {
      "checkEmail": "Vérifiez votre e-mail",
      "emailVerified": "E-mail vérifié",
      "alreadyVerified": "Tu es prête à y aller"
    },
    "ctas": {
      "continueToLogin": "Continuez à vous connecter",
      "resendEmail": "Cliquez pour renvoyer"
    },
    "noEmail": "Vous n'avez pas reçu l'e-mail ?",
    "emailSent": "Nous avons envoyé un lien de vérification à",
    "timerForResend": "en {{ time }} secondes",
    "accountVerifiedMessage": "Votre compte e-mail a été vérifié, cliquez sur le bouton ci-dessous pour vous connecter.",
    "unverifiedErrorMessage": "Nous n'avons pas pu vérifier votre compte e-mail, veuillez contacter notre équipe d'assistance au",
    "alreadyVerifiedMessage": "Ce compte e-mail a déjà été vérifié. Cliquez sur le bouton ci-dessous pour vous connecter."
  },
  "createAccount": {
    "free_trial": "Commencez l'essai gratuit",
    "marketing": "Tenez-moi au courant des dernières nouvelles et mises à jour",
    "iventisAccount": "Vous avez déjà un compte Iventis ?",
    "error": "Un problème est survenu lors de la création de votre compte. Merci de contacter",
    "disableAdBlocker": "ou essayez de désactiver votre bloqueur de publicités et réessayez."
  },
  "logout": "Déconnexion"
}